import { Collapse, Paper, Box, Typography, Divider, Avatar, Chip } from "@mui/material";
import moment from "moment";
import { IRescheduleHistory } from "../../models/periodic/rescheduleHistory";
import { TFunction } from "i18next";

export const ScheduleHistoryBox = ({ history, t, isExpanded }: { history: IRescheduleHistory[], t: TFunction, isExpanded: boolean }) => {
    if (!history?.length) return null;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {history.map((item, index) => (
                <Paper
                    key={index}
                    elevation={0}
                    sx={{
                        borderRadius: 3,
                        border: '1px solid #e0e0e0',
                        bgcolor: '#fff',
                        overflow: 'hidden',
                        position: 'relative',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            bottom: 0,
                            width: '4px',
                            bgcolor: '#3498db'
                        }
                    }}
                >
                    {/* 1. Header Section */}
                    <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                            <Avatar
                                sx={{
                                    bgcolor: 'rgba(52, 152, 219, 0.1)',
                                    color: '#3498db',
                                    width: 32,
                                    height: 32,
                                    fontSize: '0.85rem',
                                    fontWeight: 700
                                }}
                            >
                                {item.userName?.substring(0, 1).toUpperCase()}
                            </Avatar>
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
                                    {item.userName}
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    {moment.utc(item.createdAt).local().format("LLL")}
                                </Typography>
                            </Box>
                        </Box>
                        <Chip
                            label={t("periodical:history.rescheduled")}
                            size="small"
                            sx={{ bgcolor: 'rgba(52, 152, 219, 0.08)', color: '#3498db', fontWeight: 700, borderRadius: 1.5 }}
                        />
                    </Box>

                    <Collapse in={isExpanded}>
                        <Divider sx={{ borderColor: 'rgba(0,0,0,0.04)' }} />
                        <Box sx={{ p: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Box>
                                    <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', fontWeight: 700 }}>{t("periodical:history.movedFrom")}</Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
                                        {moment(item.oldDate).local().format("DD-MM-YYYY")}
                                    </Typography>
                                </Box>
                                <Typography sx={{ color: '#3498db', mt: 2 }}>→</Typography>
                                <Box>
                                    <Typography variant="caption" sx={{ display: 'block', color: '#3498db', fontWeight: 700 }}>{t("periodical:history.to")}</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 800 }}>
                                        {moment(item.newDate).local().format("DD-MM-YYYY")}
                                    </Typography>
                                </Box>
                            </Box>

                            {item.reason && (
                                <Box sx={{ mt: 2, p: 1, bgcolor: '#f8f9fa', borderRadius: 1, borderLeft: '3px solid #3498db' }}>
                                    <Typography variant="caption" sx={{ fontStyle: 'italic', display: 'block', color: 'text.secondary' }}>
                                        "{item.reason}"
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Collapse>
                </Paper>
            ))}
        </Box>
    );
};